import { loginByUsername } from "@/api/login";
import {
  removeBusinesses,
  removeCurrentBusiness,
  removeLiveAgentHash,
  removeRole,
  removeToken,
  setBusinesses,
  setCurrentBusiness,
  setLiveAgentHash,
  setRole,
  setToken,
} from "@/utils/auth";
import { selectLoginMembership } from "@/utils/loginMembership";

function clearStoredSession() {
  removeRole();
  removeBusinesses();
  removeCurrentBusiness();
  removeLiveAgentHash();
}

const user = {
  state: {
    role: null,
    username: null,
    businessName: null,
  },

  mutations: {
    SET_ROLE: (state, role) => {
      state.role = role;
    },
    SET_USERNAME: (state, username) => {
      state.username = username;
    },
    SET_BUSINESS_NAME: (state, businessName) => {
      state.businessName = businessName;
    },
  },

  actions: {
    // login
    AuthRequest({ commit }, user) {
      return new Promise((resolve, reject) => {
        loginByUsername(user.username, user.password)
          .then((response) => {
            clearStoredSession();
            commit("SET_ROLE", null);
            // save token after success login
            setToken(response.data.accessToken);
            setLiveAgentHash(response.data.liveAgentHash);
            const businesses = Array.isArray(response.data.businesses)
              ? response.data.businesses
              : [];
            setBusinesses(businesses);
            const membership = selectLoginMembership(businesses);
            const role = membership == null ? null : membership.role;
            if (membership != null) {
              if (membership.business != null) {
                setCurrentBusiness(membership);
              }
              commit("SET_ROLE", role);
              setRole(role);
            }
            const authenticatedUser = Object.assign({}, response.data, {
              role: role,
            });
            commit("SET_USERNAME", response.data.username);
            resolve(authenticatedUser);
          })
          .catch((response) => {
            removeToken();
            clearStoredSession();
            commit("SET_ROLE", null);
            console.error(response);
            reject(response);
          });
      });
    },
    setBusinessName({ commit }, businessName) {
      commit("SET_BUSINESS_NAME", businessName);
    },
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit("SET_ROLE", null);
        commit("SET_USERNAME", null);
        removeToken();
        clearStoredSession();
        resolve();
      });
    },
  },
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js